import React, { FC, PropsWithChildren } from "react";
import { CTAButton } from "../cta-button/cta-button.component";
import { Modal } from "../modal/modal.component";

type Props = {
    confirm(): void;
    cancel(): void;
}

export const ConfirmationModal: FC<PropsWithChildren<Props>> = ({ confirm, cancel, children }) => {

    return (
        <Modal>
            <div className="flex flex-col items-center justify-center px-5 gap-2">
                <p className="text-black whitespace-normal text-center mb-5">
                    {children}
                </p>
                <CTAButton
                    label="Confirm"
                    onPress={confirm}
                />
                <CTAButton
                    label="Cancel"
                    onPress={cancel}
                />
            </div>
        </Modal>
    )
}